


// import React, { useState, useEffect } from "react";
// import {
//   Box, TextField, Typography, Button, IconButton, MenuItem,
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Grid, Chip, Divider, Paper, Alert
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import AttachFileIcon from "@mui/icons-material/AttachFile";

// const PatientDetailsForm = ({ onComplete, initialData, userEmail, orderType, userData: propUserData }) => {
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [dialogMessage, setDialogMessage] = useState("");
  
//   const [patientType, setPatientType] = useState("self");
//   const [selectedFamilyMember, setSelectedFamilyMember] = useState("");
//   const [doctorname, setDoctorName] = useState("");

//   const [name, setName] = useState("");
//   const [dob, setDob] = useState("");
//   const [phone, setPhone] = useState("");
//   const [gender, setGender] = useState("");
//   const [prescription, setPrescription] = useState([]);

//   const [familyMembers, setFamilyMembers] = useState([]);
//   const [userData, setUserData] = useState(null);

//   const [errors, setErrors] = useState({});
//   const [touched, setTouched] = useState({});
//   const isEditMode = Boolean(initialData);
//   const [initialApplied, setInitialApplied] = useState(false);

//   const [selfDataChanged, setSelfDataChanged] = useState(false);
//   const [originalSelfData, setOriginalSelfData] = useState({ age: "", gender: "" });

//   // ✅ CHANGE 1: Function to fetch fresh user data from sessionStorage/API
//   const fetchFreshUserData = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const storedUser = JSON.parse(sessionStorage.getItem("user"));
      
//       if (!token || !storedUser) {
//         console.log("No token or user data found");
//         return propUserData || storedUser;
//       }

//       // Optional: Fetch from API to ensure data is completely fresh
//       // If you have a user profile API endpoint, call it here
//       // For now, we'll use the updated sessionStorage data
//       const updatedUser = JSON.parse(sessionStorage.getItem("user"));
//       console.log("✅ Fetched fresh user data:", updatedUser);
//       return updatedUser;
//     } catch (error) {
//       console.error("Error fetching fresh user data:", error);
//       return propUserData || JSON.parse(sessionStorage.getItem("user"));
//     }
//   };
//   useEffect(() => {
//     // ✅ Load data SYNCHRONOUSLY (not async)
//     const storedUser = propUserData || JSON.parse(sessionStorage.getItem("user") || "{}");
    
//     console.log("📋 Initial load - User data:", storedUser);
    
//     // ✅ Set userData immediately
//     setUserData(storedUser);
    
//     // ✅ Set family members if available
//     if (Array.isArray(storedUser.family_members)) {
//       setFamilyMembers(storedUser.family_members);
//     }
  
//     // ✅ If initialData exists (edit mode), use it
//     if (initialData) {
//       console.log("📝 Applying initial data:", initialData);
//       setPatientType(initialData.patientType || "self");
//       setSelectedFamilyMember(initialData.selectedFamilyMember || "");
//       setName(initialData.name || "");
//       setDob(initialData.dob || "");
//       setGender(initialData.gender || "");
//       setPhone(initialData.phone || "");
//       setDoctorName(initialData.doctorname || "");
//       setPrescription(initialData.prescription || []);
//       setInitialApplied(true);
//     } 
//     // ✅ Otherwise, populate with user data (for "self" default)
//     else if (storedUser && storedUser.name) {
//       console.log("👤 Populating self data");
//       setName(storedUser.name || "");
//       setPhone(storedUser.phone || "");
//       setGender(storedUser.gender || "");
//       setDob(storedUser.age || "");
//       setOriginalSelfData({
//         age: storedUser.age || "",
//         gender: storedUser.gender || ""
//       });
//     }
//   }, []); // ✅ Empty array - run ONLY ONCE on mount
//   // useEffect(() => {
//   //   const loadInitialData = async () => {
//   //     const freshUserData = await fetchFreshUserData();
//   //     setUserData(freshUserData || propUserData || JSON.parse(sessionStorage.getItem("user")) || {});
  
//   //     if (Array.isArray(freshUserData?.family_members)) {
//   //       setFamilyMembers(freshUserData.family_members);
//   //     }
  
//   //     if (initialData) {
//   //       setPatientType(initialData.patientType || "self");
//   //       setSelectedFamilyMember(initialData.selectedFamilyMember || "");
//   //       setDoctorName(initialData.doctorname || "");
//   //       setPrescription(initialData.prescription || []);
//   //     }
//   //   };

//   //   loadInitialData();
//   // }, [initialData, propUserData]);

//   useEffect(() => {
//     if (!userData) return;
  
//     // APPLY initialData ONLY ONCE
//     if (initialData && !initialApplied) {
//       setPatientType(initialData.patientType || "self");
//       setSelectedFamilyMember(initialData.selectedFamilyMember || "");
//       setName(initialData.name || "");
//       setDob(initialData.dob || "");
//       setGender(initialData.gender || "");
//       setPhone(initialData.phone || "");
//       setInitialApplied(true);
//       return;
//     }
  
//     // SELF
//     if (patientType === "self") {
//       setName(userData.name || "");
//       setPhone(userData.phone || "");
//       setGender(userData.gender || "");
//       setDob(userData.age || "");
//       setOriginalSelfData({
//         age: userData.age || "",
//         gender: userData.gender || ""
//       });
//     }
  
//     // FAMILY (selected)
//     else if (patientType === "family" && selectedFamilyMember) {
//       const member = familyMembers.find(
//         (m) => m.name === selectedFamilyMember
//       );
  
//       if (member) {
//         setName(member.name || "");
//         setGender(member.gender || "");
//         setDob(member.age || "");
//         setPhone(userData.phone || "");
//       }
//     }
  
//     // FAMILY (no selection)
//     else if (patientType === "family") {
//       setName("");
//       setGender("");
//       setDob("");
//       setPhone(userData.phone || "");
//     }
  
//     else if (patientType === "new") {
//       if (!initialData) {
//         setName("");
//         setGender("");
//         setDob("");
//         setPhone("");
//       }
//     }
//   }, [
//     patientType,
//     selectedFamilyMember,
//     userData,
//     familyMembers,
//     initialData,
//     initialApplied
//   ]);

//   const validateName = (value) => /^[A-Za-z\s]+$/.test(value);

//   const validateField = (field, value) => {
//     let error = "";

//     switch (field) {
//       case "name":
//         if (!value.trim()) {
//           error = "Name is required";
//         } else if (value.trim().length < 2) {
//           error = "Name must be at least 2 characters";
//         } else if (!validateName(value)) {
//           error = "Name should contain only alphabets";
//         }
//         break;

//       case "dob":
//         if (!value) {
//           error = "Age is required";
//         } else if (parseInt(value) < 1 || parseInt(value) > 99) {
//           error = "Age must be between 1 and 99";
//         }
//         break;

//       case "phone":
//         if (!value) {
//           error = "Phone number is required";
//         } else if (value.length < 10) {
//           error = "Phone must be 10 digits";
//         } else if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
//           error = "Enter a valid Indian phone number";
//         }
//         break;

//       case "gender":
//         if (!value) {
//           error = "Please select a gender";
//         }
//         break;

//       case "familyMember":
//         if (patientType === "family" && !value) {
//           error = "Please select a family member";
//         }
//         break;
//     }

//     return error;
//   };




//   // ✅ CHANGE 2: Updated updateUserProfile to refresh data after update
//   const updateUserProfile = async (age, gender) => {
//     try {
//       const token = sessionStorage.getItem("token");
      
//       if (!token) {
//         console.error("No authentication token found");
//         return false;
//       }

//       const response = await fetch(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify({
//           age: parseInt(age),
//           gender: gender
//         })
//       });

//       const data = await response.json();

//       if (data.success) {
//         // Update session storage with new user data
//         const updatedUser = data.user;
//         sessionStorage.setItem("user", JSON.stringify(updatedUser));
        
//         // ✅ CHANGE 3: Fetch fresh data and update state immediately
//         const freshUserData = await fetchFreshUserData();
//         setUserData(freshUserData);
        
//         // Update original self data to reflect new values
//         setOriginalSelfData({
//           age: freshUserData.age || "",
//           gender: freshUserData.gender || ""
//         });
        
//         console.log("✅ User profile updated and data refreshed successfully");
//         return true;
//       } else {
//         console.error("Failed to update profile:", data.error);
//         return false;
//       }
//     } catch (error) {
//       console.error("Error updating user profile:", error);
//       return false;
//     }
//   };

//   const handleContinue = async () => { 
//     const fieldsToValidate = {
//       name,
//       dob,
//       phone,
//       gender,
//     };

//     if (patientType === "family") {
//       fieldsToValidate.familyMember = selectedFamilyMember;
//     }

//     const newErrors = {};
//     Object.keys(fieldsToValidate).forEach((field) => {
//       const error = validateField(field, fieldsToValidate[field]);
//       if (error) {
//         newErrors[field] = error;
//       }
//     });

//     setErrors(newErrors);
//     setTouched({
//       name: true,
//       dob: true,
//       phone: true,
//       gender: true,
//       familyMember: true,
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setDialogMessage("Please fill all required fields correctly");
//       setDialogOpen(true);
//       return;
//     }

//     // Move the profile update check AFTER validation
//     if (patientType === "self") {
//       const ageChanged = dob !== originalSelfData.age;
//       const genderChanged = gender !== originalSelfData.gender;
      
//       if (ageChanged || genderChanged) {
//         // Update the profile in backend
//         const updateSuccess = await updateUserProfile(dob, gender);
        
//         if (!updateSuccess) {
//           setDialogMessage("Failed to update profile. Please try again.");
//           setDialogOpen(true);
//           return;
//         }
//       }
//     }

//     const patientDetails = {
//       patientType,
//       selectedFamilyMember,
//       name,
//       dob,
//       gender,
//       phone,
//       doctorname,
//       prescription,
//       userEmail,
//       orderType,
//     };

//     onComplete(patientDetails);
//   };

//   const fieldStyle = {
//     '& .MuiInputBase-root': {
//       borderRadius: 2,
//     },
//   };

//   const handleAgeChange = (value) => {
//     if (value === "" || (/^\d+$/.test(value) && value.length <= 2 && parseInt(value) > 0)) {
//       setDob(value);
//       if (patientType === "self" && value !== originalSelfData.age) {
//         setSelfDataChanged(true);
//       }
//       if (touched.dob) {
//         const error = validateField("dob", value);
//         setErrors((prev) => ({ ...prev, dob: error }));
//       }
//     }
//   };

//   const handleGenderChange = (value) => {
//     setGender(value);
//     if (patientType === "self" && value !== originalSelfData.gender) {
//       setSelfDataChanged(true);
//     }
//     setTouched((prev) => ({ ...prev, gender: true }));
//     setErrors((prev) => ({ ...prev, gender: "" }));
//   };

//   return (
//     <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
//       <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b', mb: 3 }}>
//         Patient Information
//       </Typography>

//       <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
//         Please provide patient details to proceed with medicine selection
//       </Alert>

//       {/* Patient Type Selection */}
//       <Box sx={{ mb: 4 }}>
//         <Typography 
//           variant="body2" 
//           sx={{ 
//             fontWeight: 700, 
//             color: "#333", 
//             mb: 2,
//             fontSize: 14
//           }}
//         >
//           Booking For
//         </Typography>
//         <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//           <Chip
//             label="Self"
//             onClick={() => {
//               setPatientType("self");
//               setSelectedFamilyMember("");
//               setTouched({});
//               setErrors({});
//             }}
//             sx={{
//               px: 2,
//               py: 2.5,
//               height: 'auto',
//               fontSize: 14,
//               fontWeight: 500,
//               borderRadius: 2,
//               border: patientType === "self" ? '2px solid #006D77' : '1px solid #E0E0E0',
//               bgcolor: patientType === "self" ? '#E0F7FA' : '#fff',
//               color: patientType === "self" ? '#006D77' : '#666',
//               cursor: 'pointer',
//               '&:hover': {
//                 bgcolor: patientType === "self" ? '#E0F7FA' : '#F5F5F5',
//               }
//             }}
//           />
//           <Chip
//             label="Family Member"
//             onClick={() => {
//               setPatientType("family");
//               setSelectedFamilyMember("");
//               setTouched({});
//               setErrors({});
//             }}
//             sx={{
//               px: 2,
//               py: 2.5,
//               height: 'auto',
//               fontSize: 14,
//               fontWeight: 500,
//               borderRadius: 2,
//               border: patientType === "family" ? '2px solid #006D77' : '1px solid #E0E0E0',
//               bgcolor: patientType === "family" ? '#E0F7FA' : '#fff',
//               color: patientType === "family" ? '#006D77' : '#666',
//               cursor: 'pointer',
//               '&:hover': {
//                 bgcolor: patientType === "family" ? '#E0F7FA' : '#F5F5F5',
//               }
//             }}
//           />
//           <Chip
//             label="New Member"
//             onClick={() => {
//               setPatientType("new");
//               setSelectedFamilyMember("");
//               setTouched({});
//               setErrors({});
//             }}
//             sx={{
//               px: 2,
//               py: 2.5,
//               height: 'auto',
//               fontSize: 14,
//               fontWeight: 500,
//               borderRadius: 2,
//               border: patientType === "new" ? '2px solid #006D77' : '1px solid #E0E0E0',
//               bgcolor: patientType === "new" ? '#E0F7FA' : '#fff',
//               color: patientType === "new" ? '#006D77' : '#666',
//               cursor: 'pointer',
//               '&:hover': {
//                 bgcolor: patientType === "new" ? '#E0F7FA' : '#F5F5F5',
//               }
//             }}
//           />
//         </Box>
//       </Box>

//       {/* Family Member Selection */}
//       {patientType === "family" && (
//         <Box sx={{ mb: 4 }}>
//           <TextField
//             select
//             fullWidth
//             label="Select Family Member"
//             value={selectedFamilyMember}
//             onChange={(e) => {
//               setSelectedFamilyMember(e.target.value);
//               setTouched((prev) => ({ ...prev, familyMember: true }));
//               setErrors((prev) => ({ ...prev, familyMember: "" }));
//             }}
//             error={touched.familyMember && !!errors.familyMember}
//             helperText={touched.familyMember && errors.familyMember}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: '#FAFAFA',
//               }
//             }}
//           >
//             <MenuItem value="" disabled>
//               Choose a family member
//             </MenuItem>
//             {familyMembers.map((member, index) => (
//               <MenuItem key={index} value={member.name}>
//                 {member.name} ({member.relation})
//               </MenuItem>
//             ))}
//           </TextField>
//         </Box>
//       )}

//       <Divider sx={{ my: 3 }} />

//       {/* Form Fields */}
//       <Grid container spacing={2} direction="column">
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Full Name"
//             placeholder="Enter full name"
//             value={name}
//             disabled={patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")}
//             onChange={(e) => {
//               const value = e.target.value;
//               if (/^[A-Za-z\s]*$/.test(value)) {
//                 setName(value);
//                 if (touched.name) {
//                   const error = validateField("name", value);
//                   setErrors((prev) => ({ ...prev, name: error }));
//                 }
//               }
//             }}
//             onBlur={() => {
//               setTouched((prev) => ({ ...prev, name: true }));
//               const error = validateField("name", name);
//               setErrors((prev) => ({ ...prev, name: error }));
//             }}
//             error={touched.name && !!errors.name}
//             helperText={touched.name && errors.name}
//             sx={{...fieldStyle, 
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: (patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")) ? '#F5F5F5' : '#FAFAFA',
//               }
//             }}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Phone"
//             placeholder="Enter phone number"
//             value={phone}
//             disabled={patientType === "self" || patientType === "family"}
//             onChange={(e) => {
//               const value = e.target.value;
//               if (/^\d{0,10}$/.test(value)) {
//                 setPhone(value);
//                 if (touched.phone) {
//                   const error = validateField("phone", value);
//                   setErrors((prev) => ({ ...prev, phone: error }));
//                 }
//               }
//             }}
//             onBlur={() => {
//               setTouched((prev) => ({ ...prev, phone: true }));
//               const error = validateField("phone", phone);
//               setErrors((prev) => ({ ...prev, phone: error }));
//             }}
//             inputProps={{ maxLength: 10 }}
//             type="tel"
//             error={touched.phone && !!errors.phone}
//             helperText={touched.phone && errors.phone}
//             sx={{...fieldStyle, 
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: (patientType === "self" || patientType === "family") ? '#F5F5F5' : '#FAFAFA',
//               }
//             }}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Age"
//             type="number"
//             placeholder="Enter age"
//             value={dob}
//             inputProps={{ min: 1, max: 99 }}
//             onChange={(e) => handleAgeChange(e.target.value)}
//             onBlur={() => {
//               setTouched((prev) => ({ ...prev, dob: true }));
//               const error = validateField("dob", dob);
//               setErrors((prev) => ({ ...prev, dob: error }));
//             }}
//             error={touched.dob && !!errors.dob}
//             helperText={touched.dob && errors.dob}
//             sx={{...fieldStyle, 
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: (patientType === "family" && selectedFamilyMember !== "") ? '#F5F5F5' : '#FAFAFA',
//               }
//             }}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             select
//             fullWidth
//             label="Gender"
//             value={gender}
//             onChange={(e) => handleGenderChange(e.target.value)} 
//             error={touched.gender && !!errors.gender}
//             helperText={touched.gender && errors.gender}
//             sx={{
//               ...fieldStyle, 
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: (patientType === "family" && selectedFamilyMember !== "") ? '#F5F5F5' : '#FAFAFA',
//               }
//             }}
//           >
//             <MenuItem value="" disabled>
//               Select Gender
//             </MenuItem>
//             <MenuItem value="male">Male</MenuItem>
//             <MenuItem value="female">Female</MenuItem>
//             <MenuItem value="other">Other</MenuItem>
//           </TextField>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label="Doctor Name"
//             placeholder="Enter Doctor Name"
//             value={doctorname}
//             onChange={(e) => {
//               const value = e.target.value;
//               if (/^[A-Za-z\s]*$/.test(value)) {
//                 setDoctorName(value);
//                 if (touched.doctorname) {
//                   const error = validateField("doctorname", value);
//                   setErrors((prev) => ({ ...prev, doctorname: error }));
//                 }
//               }
//             }}
//             onBlur={() => {
//               setTouched((prev) => ({ ...prev, doctorname: true }));
//               const error = validateField("doctorname", doctorname);
//               setErrors((prev) => ({ ...prev, doctorname: error }));
//             }}
//             error={touched.doctorname && !!errors.doctorname}
//             helperText={touched.doctorname && errors.doctorname}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 bgcolor: '#FAFAFA',
//               }
//             }}
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <Button
//             component="label"
//             fullWidth
//             variant="outlined"
//             startIcon={<AttachFileIcon />}
//             sx={{
//               py: 1.5,
//               borderRadius: 2,
//               borderColor: '#E0E0E0',
//               color: '#666',
//               textTransform: 'none',
//               fontSize: 14,
//               fontWeight: 500,
//               bgcolor: '#FAFAFA',
//               '&:hover': {
//                 bgcolor: '#F5F5F5',
//                 borderColor: '#006D77'
//               }
//             }}
//           >
//             Medical Documents (Optional)
//             <input
//               type="file"
//               hidden
//               multiple
//               accept="image/*,.pdf"
//               onChange={(e) => setPrescription(Array.from(e.target.files))}
//             />
//           </Button>
//         </Grid>
//       </Grid>

//       {prescription.length > 0 && (
//         <Box sx={{ mt: 3, p: 2, bgcolor: '#F9F9F9', borderRadius: 2 }}>
//           <Typography variant="body2" fontWeight={600} mb={1.5} color="#333">
//             Uploaded Files ({prescription.length})
//           </Typography>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {prescription.map((file, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   p: 1.5,
//                   bgcolor: '#fff',
//                   borderRadius: 1.5,
//                   border: '1px solid #E0E0E0'
//                 }}
//               >
//                 <Typography fontSize={13} color="#555">
//                   📄 {file.name}
//                 </Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() =>
//                     setPrescription((prev) => prev.filter((_, i) => i !== index))
//                   }
//                   sx={{ 
//                     color: '#999',
//                     '&:hover': {
//                       color: '#EF4444',
//                       bgcolor: '#FEE2E2'
//                     }
//                   }}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}

//       <Button
//         fullWidth
//         variant="contained"
//         sx={{
//           mt: 4,
//           py: 1.8,
//           borderRadius: 2.5,
//           bgcolor: "#006D77",
//           fontSize: 15,
//           fontWeight: 600,
//           textTransform: 'none',
//           boxShadow: '0 4px 12px rgba(0, 109, 119, 0.3)',
//           "&:hover": { 
//             bgcolor: "#004F55",
//             boxShadow: '0 6px 16px rgba(0, 109, 119, 0.4)',
//           },
//         }}
//         onClick={handleContinue}
//       >
//         Continue to Medicine Selection
//       </Button>

//       {/* Custom Dialog */}
//       <Dialog 
//         open={dialogOpen} 
//         onClose={() => setDialogOpen(false)}
//         PaperProps={{
//           sx: { borderRadius: 3, minWidth: 300 }
//         }}
//       >
//         <DialogContent sx={{ pt: 3 }}>
//           <Typography sx={{ fontSize: 15 }}>{dialogMessage}</Typography>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button 
//             onClick={() => setDialogOpen(false)}
//             variant="contained"
//             fullWidth
//             sx={{
//               bgcolor: '#006D77',
//               textTransform: 'none',
//               '&:hover': { bgcolor: '#004F55' }
//             }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Paper>
//   );
// };

// export default PatientDetailsForm;

















import React, { useState, useEffect, useCallback } from "react";
import {
  Box, TextField, Typography, Button, IconButton, MenuItem,
  Dialog, DialogContent, DialogActions,
  Grid, Chip, Divider, Paper, Alert, CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import RefreshIcon from "@mui/icons-material/Refresh";
import { apiRequest } from '../../fetchSetup';


const PatientDetailsForm = ({ onComplete, initialData, userEmail, orderType, userData: propUserData }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  
  const [patientType, setPatientType] = useState("self");
  const [selectedFamilyMember, setSelectedFamilyMember] = useState("");
  const [doctorname, setDoctorName] = useState("");

  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [prescription, setPrescription] = useState([]);

  const [familyMembers, setFamilyMembers] = useState([]);
  const [userData, setUserData] = useState(null);

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  
  const [selfDataChanged, setSelfDataChanged] = useState(false);
  const [originalSelfData, setOriginalSelfData] = useState({ age: "", gender: "" });

  // ✅ FUNCTION TO LOAD USER DATA - Now using useCallback to prevent infinite loops
  const loadUserData = useCallback((isRefresh = false) => {
    try {
      if (isRefresh) {
        setRefreshing(true);
      } else {
        setLoading(true);
      }

      console.log(" Loading user data...", isRefresh ? "(REFRESH)" : "(INITIAL)");
      
   
      const storedUser = propUserData || JSON.parse(sessionStorage.getItem("user") || "{}");
      
      console.log(" User data loaded:", storedUser);
      
      // Set userData immediately
      setUserData(storedUser);
      
      // Set family members if available
      if (Array.isArray(storedUser.family_members)) {
        setFamilyMembers(storedUser.family_members);
      }
    
      // If initialData exists (edit mode), use it
      if (initialData) {
        console.log(" Applying initial data (Edit Mode):", initialData);
        setPatientType(initialData.patientType || "self");
        setSelectedFamilyMember(initialData.selectedFamilyMember || "");
        setName(initialData.name || "");
        setDob(initialData.dob || "");
        setGender(initialData.gender || "");
        setPhone(initialData.phone || "");
        setDoctorName(initialData.doctorname || "");
        setPrescription(initialData.prescription || []);
        setOriginalSelfData({
          age: initialData.dob || "",
          gender: initialData.gender || ""
        });
      } 
      // Otherwise, populate with user data (for "self" default)
      else if (storedUser && storedUser.name) {
        console.log("👤 Populating self data");
        setName(storedUser.name || "");
        setPhone(storedUser.phone || "");
        setGender(storedUser.gender || "");
        setDob(storedUser.age || "");
        setOriginalSelfData({
          age: storedUser.age || "",
          gender: storedUser.gender || ""
        });
      }
    } catch (error) {
      console.error(" Error loading user data:", error);
      setDialogMessage("Failed to load user data. Please refresh the page.");
      setDialogOpen(true);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [propUserData, initialData]); 

  useEffect(() => {
    let attempts = 0;
  
    const interval = setInterval(() => {
      const storedUser =
        propUserData || JSON.parse(sessionStorage.getItem("user") || "null");
  
      if (storedUser?.name) {
        console.log(" User data detected after login:::",storedUser);
        setUserData(storedUser);
        setFamilyMembers(storedUser.family_members || []);
      //  FIX: Prefill form for "self" if no initialData
      if (!initialData && patientType === "self") {
        setName(storedUser.name || "");
        setPhone(storedUser.phone || "");
        setGender(storedUser.gender || "");
        setDob(storedUser.age || "");
        setOriginalSelfData({
          age: storedUser.age || "",
          gender: storedUser.gender || ""
        });
      }


        setLoading(false);
        clearInterval(interval);
      }
  
      attempts++;
      if (attempts > 10) { // ~3 seconds max
        console.warn(" User data not found");
        setLoading(false);
        clearInterval(interval);
      }
    }, 300);
  
    return () => clearInterval(interval);
  }, [propUserData]);
  

  const prefillForm = useCallback(() => {
    if (!userData) return;
  
    console.log(" Prefilling for:", patientType);
  
    // SELF
    if (patientType === "self") {
      setName(userData.name || "");
      setPhone(userData.phone || "");
      setGender(userData.gender || "");
      setDob(userData.age || "");
      setSelectedFamilyMember("");
      return;
    }
  
    // FAMILY (with selection)
    if (patientType === "family" && selectedFamilyMember) {
      const member = familyMembers.find(
        (m) => m.name === selectedFamilyMember
      );
  
      if (member) {
        setName(member.name || "");
        setGender(member.gender || "");
        setDob(member.age || "");
        setPhone(userData.phone || "");
      }
      return;
    }
  
    // FAMILY (no selection yet)
    if (patientType === "family") {
      setName("");
      setGender("");
      setDob("");
      setPhone(userData.phone || "");
      return;
    }
  
    // NEW
    if (patientType === "new") {
      setName("");
      setGender("");
      setDob("");
      setPhone("");
    }
  }, [patientType, selectedFamilyMember, userData, familyMembers]);
  useEffect(() => {
    prefillForm();
  }, [prefillForm]);
    
  const validateName = (value) => /^[A-Za-z\s]+$/.test(value);

  const validateField = (field, value) => {
    let error = "";

    switch (field) {
      case "name":
        if (!value.trim()) {
          error = "Name is required";
        } else if (value.trim().length < 2) {
          error = "Name must be at least 2 characters";
        } else if (!validateName(value)) {
          error = "Name should contain only alphabets";
        }
        break;

      case "dob":
        if (!value) {
          error = "Age is required";
        } else if (parseInt(value) < 1 || parseInt(value) > 99) {
          error = "Age must be between 1 and 99";
        }
        break;

      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else if (value.length < 10) {
          error = "Phone must be 10 digits";
        } else if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
          error = "Enter a valid Indian phone number";
        }
        break;

      case "gender":
        if (!value) {
          error = "Please select a gender";
        }
        break;

      case "familyMember":
        if (patientType === "family" && !value) {
          error = "Please select a family member";
        }
        break;
    }

    return error;
  };

  const updateUserProfile = async (age, gender) => {
    try {
      const token = sessionStorage.getItem("token");
      
      if (!token) {
        console.error("No authentication token found");
        return false;
      }

      const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          age: parseInt(age),
          gender: gender
        })
      });

      const data = await response.json();

      if (data.success) {
        // Update session storage with new user data
        const updatedUser = data.user;
        sessionStorage.setItem("user", JSON.stringify(updatedUser));
        
        // Reload user data
        loadUserData(true);
        
        console.log(" User profile updated successfully");
        return true;
      } else {
        console.error("Failed to update profile:", data.error);
        return false;
      }
    } catch (error) {
      console.error("Error updating user profile:", error);
      return false;
    }
  };

  const handleContinue = async () => { 
    const fieldsToValidate = {
      name,
      dob,
      phone,
      gender,
    };

    if (patientType === "family") {
      fieldsToValidate.familyMember = selectedFamilyMember;
    }

    const newErrors = {};
    Object.keys(fieldsToValidate).forEach((field) => {
      const error = validateField(field, fieldsToValidate[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);
    setTouched({
      name: true,
      dob: true,
      phone: true,
      gender: true,
      familyMember: true,
    });

    if (Object.keys(newErrors).length > 0) {
      setDialogMessage("Please fill all required fields correctly");
      setDialogOpen(true);
      return;
    }

    // Move the profile update check AFTER validation
    if (patientType === "self") {
      const ageChanged = dob !== originalSelfData.age;
      const genderChanged = gender !== originalSelfData.gender;
      
      if (ageChanged || genderChanged) {
        // Update the profile in backend
        const updateSuccess = await updateUserProfile(dob, gender);
        
        if (!updateSuccess) {
          setDialogMessage("Failed to update profile. Please try again.");
          setDialogOpen(true);
          return;
        }
      }
    }

    const patientDetails = {
      patientType,
      selectedFamilyMember,
      name,
      dob,
      gender,
      phone,
      doctorname,
      prescription,
      userEmail,
      orderType,
    };

    onComplete(patientDetails);
  };

  const fieldStyle = {
    '& .MuiInputBase-root': {
      borderRadius: 2,
    },
  };

  const handleAgeChange = (value) => {
    if (value === "" || (/^\d+$/.test(value) && value.length <= 2 && parseInt(value) > 0)) {
      setDob(value);
      if (patientType === "self" && value !== originalSelfData.age) {
        setSelfDataChanged(true);
      }
      if (touched.dob) {
        const error = validateField("dob", value);
        setErrors((prev) => ({ ...prev, dob: error }));
      }
    }
  };

  const handleGenderChange = (value) => {
    setGender(value);
    if (patientType === "self" && value !== originalSelfData.gender) {
      setSelfDataChanged(true);
    }
    setTouched((prev) => ({ ...prev, gender: true }));
    setErrors((prev) => ({ ...prev, gender: "" }));
  };

  // ✅ MANUAL REFRESH HANDLER
  const handleRefresh = () => {
    console.log(" Manual refresh triggered");
    loadUserData(true);
    // Reset errors and touched state
    setErrors({});
    setTouched({});
  };

  // SHOW LOADING STATE
  if (loading) {
    return (
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300 }}>
          <CircularProgress size={48} sx={{ color: '#006D77', mb: 2 }} />
          <Typography variant="body2" color="text.secondary">
            Loading patient details...
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', position: 'relative' }}>
      {/* Refresh Button */}
      <IconButton
        onClick={handleRefresh}
        disabled={refreshing}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          color: '#006D77',
          '&:hover': {
            bgcolor: '#E0F7FA'
          }
        }}
        title="Refresh patient data"
      >
        {refreshing ? <CircularProgress size={24} /> : <RefreshIcon />}
      </IconButton>

      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b', mb: 3 }}>
        Patient Information
      </Typography>

      <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
        Please provide patient details to proceed with medicine selection
      </Alert>

      {/* Patient Type Selection */}
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 700, 
            color: "#333", 
            mb: 2,
            fontSize: 14
          }}
        >
          Booking For
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Chip
            label="Self"
            onClick={() => {
              setPatientType("self");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "self" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "self" ? '#E0F7FA' : '#fff',
              color: patientType === "self" ? '#006D77' : '#666',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: patientType === "self" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
          <Chip
            label="Family Member"
            onClick={() => {
              setPatientType("family");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "family" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "family" ? '#E0F7FA' : '#fff',
              color: patientType === "family" ? '#006D77' : '#666',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: patientType === "family" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
          <Chip
            label="New Member"
            onClick={() => {
              setPatientType("new");
              setSelectedFamilyMember("");
              setTouched({});
              setErrors({});
            }}
            sx={{
              px: 2,
              py: 2.5,
              height: 'auto',
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 2,
              border: patientType === "new" ? '2px solid #006D77' : '1px solid #E0E0E0',
              bgcolor: patientType === "new" ? '#E0F7FA' : '#fff',
              color: patientType === "new" ? '#006D77' : '#666',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: patientType === "new" ? '#E0F7FA' : '#F5F5F5',
              }
            }}
          />
        </Box>
      </Box>

      {/* Family Member Selection */}
      {patientType === "family" && (
        <Box sx={{ mb: 4 }}>
          <TextField
            select
            fullWidth
            label="Select Family Member"
            value={selectedFamilyMember}
            onChange={(e) => {
              setSelectedFamilyMember(e.target.value);
              setTouched((prev) => ({ ...prev, familyMember: true }));
              setErrors((prev) => ({ ...prev, familyMember: "" }));
            }}
            error={touched.familyMember && !!errors.familyMember}
            helperText={touched.familyMember && errors.familyMember}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          >
            <MenuItem value="" disabled>
              Choose a family member
            </MenuItem>
            {familyMembers.map((member, index) => (
              <MenuItem key={index} value={member.name}>
                {member.name} ({member.relation})
              </MenuItem>
            ))}
          </TextField>
        </Box>
      )}

      <Divider sx={{ my: 3 }} />

      {/* Form Fields */}
      <Grid container spacing={2} direction="column">
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Full Name"
            placeholder="Enter full name"
            value={name}
            disabled={patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[A-Za-z\s]*$/.test(value)) {
                setName(value);
                if (touched.name) {
                  const error = validateField("name", value);
                  setErrors((prev) => ({ ...prev, name: error }));
                }
              }
            }}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, name: true }));
              const error = validateField("name", name);
              setErrors((prev) => ({ ...prev, name: error }));
            }}
            error={touched.name && !!errors.name}
            helperText={touched.name && errors.name}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: (patientType === "self" || (patientType === "family" && selectedFamilyMember !== "")) ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Phone"
            placeholder="Enter phone number"
            value={phone}
            disabled={patientType === "self" || patientType === "family"}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                setPhone(value);
                if (touched.phone) {
                  const error = validateField("phone", value);
                  setErrors((prev) => ({ ...prev, phone: error }));
                }
              }
            }}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, phone: true }));
              const error = validateField("phone", phone);
              setErrors((prev) => ({ ...prev, phone: error }));
            }}
            inputProps={{ maxLength: 10 }}
            type="tel"
            error={touched.phone && !!errors.phone}
            helperText={touched.phone && errors.phone}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: (patientType === "self" || patientType === "family") ? '#F5F5F5' : '#FAFAFA',
              }
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Age"
            type="number"
            placeholder="Enter age"
            value={dob}
            inputProps={{ min: 1, max: 99 }}
            onChange={(e) => handleAgeChange(e.target.value)}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, dob: true }));
              const error = validateField("dob", dob);
              setErrors((prev) => ({ ...prev, dob: error }));
            }}
            error={touched.dob && !!errors.dob}
            helperText={touched.dob && errors.dob}
            sx={{...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Gender"
            value={gender}
            onChange={(e) => handleGenderChange(e.target.value)} 
            error={touched.gender && !!errors.gender}
            helperText={touched.gender && errors.gender}
            sx={{
              ...fieldStyle, 
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          >
            <MenuItem value="" disabled>
              Select Gender
            </MenuItem>
            <MenuItem value="male">Male</MenuItem>
            <MenuItem value="female">Female</MenuItem>
            <MenuItem value="other">Other</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Doctor Name"
            placeholder="Enter Doctor Name"
            value={doctorname}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[A-Za-z\s]*$/.test(value)) {
                setDoctorName(value);
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: '#FAFAFA',
              }
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            component="label"
            fullWidth
            variant="outlined"
            startIcon={<AttachFileIcon />}
            sx={{
              py: 1.5,
              borderRadius: 2,
              borderColor: '#E0E0E0',
              color: '#666',
              textTransform: 'none',
              fontSize: 14,
              fontWeight: 500,
              display:'none',
              bgcolor: '#FAFAFA',
              '&:hover': {
                bgcolor: '#F5F5F5',
                borderColor: '#006D77'
              }
            }}
          >
            Medical Documents (Optional)
            <input
              type="file"
              hidden
              multiple
              accept="image/*,.pdf"
              onChange={(e) => setPrescription(Array.from(e.target.files))}
            />
          </Button>
        </Grid>
      </Grid>

      {prescription.length > 0 && (
        <Box sx={{ mt: 3, p: 2, bgcolor: '#F9F9F9', borderRadius: 2 }}>
          <Typography variant="body2" fontWeight={600} mb={1.5} color="#333">
            Uploaded Files ({prescription.length})
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {prescription.map((file, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1.5,
                  bgcolor: '#fff',
                  borderRadius: 1.5,
                  border: '1px solid #E0E0E0'
                }}
              >
                <Typography fontSize={13} color="#555">
                  📄 {file.name}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() =>
                    setPrescription((prev) => prev.filter((_, i) => i !== index))
                  }
                  sx={{ 
                    color: '#999',
                    '&:hover': {
                      color: '#EF4444',
                      bgcolor: '#FEE2E2'
                    }
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      <Button
        fullWidth
        variant="contained"
        sx={{
          mt: 4,
          py: 1.8,
          borderRadius: 2.5,
          bgcolor: "#006D77",
          fontSize: 15,
          fontWeight: 600,
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(0, 109, 119, 0.3)',
          "&:hover": { 
            bgcolor: "#004F55",
            boxShadow: '0 6px 16px rgba(0, 109, 119, 0.4)',
          },
        }}
        onClick={handleContinue}
      >
         Continue →
      </Button>

      {/* Custom Dialog */}
      <Dialog 
        open={dialogOpen} 
        onClose={() => setDialogOpen(false)}
        PaperProps={{
          sx: { borderRadius: 3, minWidth: 300 }
        }}
      >
        <DialogContent sx={{ pt: 3 }}>
          <Typography sx={{ fontSize: 15 }}>{dialogMessage}</Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setDialogOpen(false)}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: '#006D77',
              textTransform: 'none',
              '&:hover': { bgcolor: '#004F55' }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default PatientDetailsForm;